export default class CooldownHandler {

    catchLast:boolean;
    delay:number;
    hasCooldown:boolean = false;
    queuedCallback:((resolved:boolean) => void)|null = null

    constructor(catchLast:boolean = false, delay:number = 1000)
    {
        this.catchLast = catchLast;
        this.delay = Math.max(Math.round(delay), 1);
    }

    async available():Promise<void>
    {
        return new Promise((resolve, reject) => {
            if(this.hasCooldown){
                if(this.queuedCallback){
                    this.queuedCallback(false)
                }
                this.queuedCallback = this.catchLast ? (resolved:boolean) => {
                    if(!resolved || this.hasCooldown){
                        return;
                    }
                    this.available().then(() =>{
                        resolve();
                    })
                } : null;
                return;
            }
            this.hasCooldown = true;
            this.queuedCallback = null;
            resolve();
            setTimeout(()=>{
                this.hasCooldown = false;
                if(this.queuedCallback){
                    this.queuedCallback(true)
                }
            }, this.delay)
        });
    }
}